import { render, staticRenderFns } from "./vIngredientManagement.vue?vue&type=template&id=e172733a&scoped=true"
import script from "./vIngredientManagement.vue?vue&type=script&lang=ts"
export * from "./vIngredientManagement.vue?vue&type=script&lang=ts"
import style0 from "./vIngredientManagement.vue?vue&type=style&index=0&id=e172733a&prod&lang=css"
import style1 from "./vIngredientManagement.vue?vue&type=style&index=1&id=e172733a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e172733a",
  null
  
)

export default component.exports